import script from "./ModalSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalSuccess.vue?vue&type=script&setup=true&lang=js"

import "./ModalSuccess.vue?vue&type=style&index=0&id=e6eb3746&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6eb3746"]])

export default __exports__